import React, { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import chevron_down from "../assets/Vehicles/chevron_down.png";
import tata from "../assets/Vehicles/tata.png";
import playback from "../assets/Dashboard/playback.png";
import close from "../assets/Dashboard/close.png";
import mapFlag from "../assets/png/location-flag.png";
import mapLorryFlag from "../assets/png/map-lorry-png.png";
import { Clock } from "lucide-react";
import { GoogleMap, Marker, Polyline, useJsApiLoader } from "@react-google-maps/api";
import CommonDropdown from "./common/common_dropDown";
import { getVehicleDetailAPI } from "./Vehicles/Vehicle_assignment/vehicle_assigne_api";
import dayjs from "dayjs";
import polyline from "@mapbox/polyline";
import { getLiveMapApi } from "./dashboard_api";
export const Location = () => {
  const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAP_KEY;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [center, setCenter] = useState({ lat: 28.6139, lng: 77.209 });
  const [zoom, setZoom] = useState(14);
  const [updateFlag, setUpdateFlag] = useState(0);
  const animateCamera = (latLng) => {
    setCenter(latLng); // move camera
    setZoom(15); // adjust zoom
  };

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
  });
  const [marker, setMarker] = useState([]);
  // slider
  const [showSlider, setShowSlider] = useState(false); // Toggle between button & slider

  const min = 0;
  const max = 100;
  const [value, setValue] = useState(50);
  const [endHour, setEndHour] = useState(0);

  // const handleChange = (e) => {
  //   const value = Number(e.target.value);
  //   setEndHour(value);
  // };
  function parse12HourString(str) {
    // str = "2024-10-22 11:57 PM"
    const [datePart, timePart, ampm] = str.split(" "); // ["2024-10-22", "11:57", "PM"]
    const [hoursStr, minutesStr] = timePart.split(":");
    let hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;

    const [year, month, day] = datePart.split("-").map(Number);

    // month in JS Date is 0-indexed
    return new Date(year, month - 1, day, hours, minutes, 0, 0);
  }
  const parseTime12Hour = (timeStr) => {
    const today = new Date();
    const [timePart, ampm] = timeStr.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;

    return new Date(today.getFullYear(), today.getMonth(), today.getDate(), hours, minutes, 0, 0);
  };
  function parseDate12Hour(dateStr) {
    // dateStr = "2024-10-22 11:57 PM"
    const [datePart, timePart, ampm] = dateStr.split(" "); // ["2024-10-22", "11:57", "PM"]
    const [year, month, day] = datePart.split("-").map(Number);
    let [hours, minutes] = timePart.split(":").map(Number);

    if (ampm === "PM" && hours < 12) hours += 12;
    if (ampm === "AM" && hours === 12) hours = 0;

    return new Date(year, month - 1, day, hours, minutes, 0, 0);
  }

  const handleChange = (e) => {
    const value = parseInt(e.target.value, 10);
    console.log("Slider value changed:", value);
    setEndHour(value);

    if (!startTime12 || !dateString) {
      console.warn("Start time or start date missing");
      return;
    }
    console.log("Parsed startDate:", dateString);
    // Parse start date + time (e.g., "2024-10-22 11:57 PM")
    const startDate1 = parseDate12Hour(dateString);
    console.log("Parsed startDate:", startDate1);

    const newEndTime = new Date(startDate1.getTime() + value * 3600 * 1000);
    console.log("Calculated newEndTime:", newEndTime);
    setEndTime(newEndTime);

    // Filter playback history
    const filtered = playbackRouteHistory.filter((element) => {
      if (element.date) {
        const recordDate = parseDate12Hour(element.date);
        console.log(`Filtering element date: ${element.date}, recordDate: ${recordDate}, newEndTime: ${newEndTime}`);
        return recordDate <= newEndTime;
      }
      return false;
    });

    console.log("Filtered playbackRouteHistory:", filtered);

    if (filtered.length > 0) {
      console.log("Creating polylines for filtered data...");
      createPolylines(filtered, "history");
    } else {
      console.log("No filtered data, clearing polylines and markers");
      setPolylines({});
      setMarker([]);
      setFlagMarker(null);
      setUpdateFlag((prev) => prev + 1);
    }
  };

  // Format endTime like Flutter's DateFormat
  const formatEndTime = (date) => {
    if (!date) return "";
    const pad = (num) => String(num).padStart(2, "0");
    const hours12 = date.getHours() % 12 || 12;
    const ampm = date.getHours() >= 12 ? "PM" : "AM";
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(hours12)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
  };

  // const handleChange = (e) => {
  //   const value = parseInt(e.target.value, 10);
  //   setEndHour(value);
  //   console.log("value", value);
  //   if (!startTime12) return; // safeguard
  //   // Suppose startTime12 = "2025-09-23 10:30:00 AM" (string)
  //   const startDate = parse12HourString(startTime12);
  //   const newEndTime = new Date(startDate.valueOf() + value * 3600 * 1000);

  //   setEndTime(newEndTime);
  //   console.log("value", startTime12);
  //   console.log("value", startDate);

  //   console.log("Endvalue", newEndTime);
  //   // setEndTime12(
  //   //   newEndTime.toLocaleTimeString("en-US", {
  //   //     hour: "2-digit",
  //   //     minute: "2-digit",
  //   //     second: "2-digit",
  //   //     hour12: true,
  //   //   })
  //   // );
  //   // setEndDate(newEndTime.toLocaleDateString("en-CA"));

  //   const filtered = playbackRouteHistory.filter((element) => {
  //     if (element.date) {
  //       const recordDate = new Date(element.date);
  //       return recordDate <= newEndTime;
  //     }
  //     return false;
  //   });
  //   console.log("filtered", filtered);
  //   if (filtered.length > 0) {
  //     createPolylines(filtered, "history");
  //   } else {
  //     setPolylines({});
  //     setMarker([]);
  //     setUpdateFlag((prev) => prev + 1);
  //     setFlagMarker(null);
  //   }
  // };

  const [selectedLicensePlate, setSelectedLicensePlate] = useState(null);
  const [vehicleDetails, setVehicleDetails] = useState({});
  const handleSelectVin = (item) => {
    console.log("Selected:", item);
    setSelectedLicensePlate(item); // store selected id
  };

  useEffect(() => {
    getVehicleDetails();
    getPlaybackLocationRoute();
  }, [selectedLicensePlate]); //
  const getVehicleDetails = async () => {
    try {
      if (!selectedLicensePlate?.value) return; // safety check

      const response = await getVehicleDetailAPI(selectedLicensePlate.value);

      console.log("vehicle details", response);
      if (response.data?.success) {
        const vehicleData = response.data.vehicle;
        setVehicleDetails(vehicleData);
      } else {
        console.error("Failed to fetch vehicle details:", response.data?.message);
      }
    } catch (err) {
      console.error("Error fetching vehicle details:", err);
    }
  };
  const parseDateTime = (dateString) => {
    // dateString format: "2024-10-22 11:57 PM"
    const [datePart, timePart, meridian] = dateString.split(" ");
    const [year, month, day] = datePart.split("-").map(Number);
    let [hour, minute] = timePart.split(":").map(Number);

    // convert 12-hour format to 24-hour format
    if (meridian.toUpperCase() === "PM" && hour !== 12) {
      hour += 12;
    } else if (meridian.toUpperCase() === "AM" && hour === 12) {
      hour = 0;
    }

    // month is 0-indexed in JS Date
    return new Date(year, month - 1, day, hour, minute, 0, 0);
  };

  const formatDate = (date) => {
    const options = { month: "long", day: "2-digit" };
    return date.toLocaleDateString("en-US", options); // e.g., October 22
  };

  const formatTime = (date) => {
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const [dateString, setdateString] = useState(null);
  const [enddateString, setnddateString] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [endTime, setEndTime] = useState(null);
  const [startDate, setStartDate] = useState("");
  const [startTime12, setStartTime12] = useState("");
  const [endDate, setEndDate] = useState("");
  const [endTime12, setEndTime12] = useState("");
  const [totalDurationHours, setTotalDurationHours] = useState(0);
  const [playbackRouteHistory, setPlaybackRouteHistory] = useState([]);
  const [totalKM, setTotalKM] = useState("");
  const [runningFrom, setRunningFrom] = useState("");
  const [lastUpdate, setLastUpdate] = useState("");
  const getPlaybackLocationRoute = async () => {
    console.log("fetching playback route for:", selectedLicensePlate);
    if (!selectedLicensePlate?.value) return; // safety check
    const body = { id: selectedLicensePlate?.value };
    try {
      const response = await getLiveMapApi(body);

      console.log("play back...", response.data);
      var data = response.data;
      if (response.data.success) {
        const dateString = data.start_date || "2024-10-21 11:57 PM";
        const enddateString = data.end_date || "2024-10-25 11:46 PM";
        setdateString(data.start_date || "2024-10-21 11:57 PM");
        setnddateString(data.end_date || "2024-10-25 11:46 PM");
        const start = parseDateTime(dateString);
        const end = parseDateTime(enddateString);

        updatePlaybackData(start, end, data);

        if ((data.trackings || []).length > 0) {
          createPolylines(data.trackings, "history");
        }
      }
    } catch (error) {
      console.error("Error fetching playback route:", error);
    }
  };

  function updatePlaybackData(start, end, data) {
    // Format dates and times
    setStartDate(dayjs(start).format("MMMM DD"));
    setStartTime12(dayjs(start).format("hh:mm A"));
    setEndDate(dayjs(end).format("MMMM DD"));
    setEndTime12(dayjs(end).format("hh:mm A"));

    // Calculate duration in hours
    const diff = (end - start) / (1000 * 60 * 60); // ms → hours
    setTotalDurationHours(diff);
    setEndHour(diff);

    // Other playback info
    setPlaybackRouteHistory(data.trackings || []);
    setTotalKM(data.km?.toString() || "");
    setRunningFrom(data.from || "");
    setLastUpdate(data.last_update || "");
  }

  const createPolylines = (playbackRoute, type) => {
    console.log("Enter Creating Polyine");
    if (!isLoaded) {
      console.log("Map is not initialized");
      return;
    }

    // Remove existing polylines of this type
    removePolylines(type);
    console.log("Enter Creating Polyine After remove");
    playbackRoute.forEach((route, i) => {
      const points = polyline.decode(route.points || ""); // You'll need to implement this
      console.log("Inside playbackRoute before Return");
      if (points.length === 0) return;
      console.log("Inside playbackRoute after Return");
      // Add marker at the first point of the first route
      if (i === 0 && points.length > 0) {
        console.log("Inside addStartMarker");
        setFlagMarker(null);
        addStartFirstMarker(points[0]);
        animateCamera({ lat: points[0][0], lng: points[0][1] });
      }

      // Add polyline
      const polylineId = `poly${type}${i}`;
      addPolyline(polylineId, points, type);
      console.log("Add Polyline", polylineId);
      console.log("Add Polyline", points);
      console.log("Add Polyline", type);
      // Store all history coordinates if needed
      if (type === "history") {
        setAllCoordinatesHistory((prev) => [...prev, ...points]);
      }
      // if (i === 0 && points.length > 0) {
      //   console.log("Inside addStartMarker");
      //   addStartMarker(points[0]); // works if points[0] = [lat, lng]
      // }
    });
  };
  const removePolylines = (type) => {
    setPolylines((prev) => {
      const newPolylines = { ...prev };

      Object.keys(newPolylines).forEach((key) => {
        const item = newPolylines[key];

        if (item && item.type === type && item.polyline) {
          item.polyline.setMap(null); // safely remove polyline
          delete newPolylines[key];
        }
      });

      return newPolylines;
    });
  };

  // Google map instance
  const [polylines, setPolylines] = useState({});
  const [startMarker, setStartMarker] = useState(null);
  const [allCoordinatesHistory, setAllCoordinatesHistory] = useState([]);

  const addPolyline = (id, coordinates, type) => {
    // coordinates is [[lat, lng], [lat, lng], ...]
    const path = coordinates
      .map(([lat, lng]) => ({
        lat: Number(lat),
        lng: Number(lng),
      }))
      .filter((p) => !isNaN(p.lat) && !isNaN(p.lng));

    setPolylines((prev) => ({
      ...prev,
      [id]: { path, type },
    }));

    console.log("polylines....>", path);
    console.log("polylines....>111", polylines);
  };
  const [flagMarker, setFlagMarker] = useState(null);

  const addStartFirstMarker = (coordinate) => {
    setFlagMarker({
      id: "Flag",
      position: { lat: coordinate[0], lng: coordinate[1] },
      icon: {
        url: mapFlag,
        scaledSize: new window.google.maps.Size(50, 50),
      },
    });
  };

  const addStartMarker = (coordinate) => {
    setMarker((prev) => [
      ...prev,
      {
        id: Date.now(),
        position: { lat: coordinate.latitude, lng: coordinate.longitude },
      },
    ]);
  };
  return (
    <>
      <div className="w-100 bg-half-white">
        <div className="row w-100 p-3">
          <div className="col-xl-6 h-100">
            <div className="bg-white rounded-4 p-3">
              <p className="m-0 fs-24 fw-700 text-dark-purple">Location detection</p>
              <label htmlFor="vin" className="form-label fw-400 mt-5">
                License Plate
              </label>
              <CommonDropdown apiUrl={`${apiUrl}get_vehicle`} placeholder="Select license  plate" value={selectedLicensePlate} onSelect={handleSelectVin} />{" "}
            </div>
          </div>
          <div className="col-xl-6">
            <div class="divider mb-1">
              <span style={{ color: "#626F86" }}>Selected Vehicle</span>
            </div>
            <div className="bg-white rounded-4 p-2">
              <div className="d-flex gap-2 align-items-center">
                <div className="bg-half-white rounded-4">
                  <img src={tata} alt="tata" />
                </div>
                <div style={{ paddingLeft: "12px" }}>
                  <p className="m-0 fs-20 fw-semibold mb-1">{selectedLicensePlate?.label ?? ""}</p>
                  <div className="d-flex align-items-center">
                    <span className="me-2 text-muted-grey">{vehicleDetails.name ?? ""}</span>
                    {/* <span className="me-2">•</span> */}
                    {/* <span className="border-0 bg-list-purple text-dark-purple py-1 px-4 rounded-pill">
                        {vehicleDetails.vehicle_type ?? ""}
                      </span> */}
                  </div>
                </div>
              </div>
              <div className="bg-half-white rounded-pill mt-2 p-3 d-flex align-items-center gap-3">
                <p className="m-0" style={{ color: "#8790A1" }}>
                  Vehicle identification number (VIN){" "}
                </p>
                <p className="m-0" style={{ color: "#8790A1" }}>
                  :
                </p>
                <p className="m-0"> {vehicleDetails.vin ?? ""}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="row w-100 p-3">
          <div className="col-12">
            <div className="bg-white rounded-4 p-3">
              <div className="d-flex flex-column flex-xl-row align-items-center justify-content-between mb-3">
                <div className="d-flex flex-column">
                  <p className="fs-25 fw-700"> {selectedLicensePlate?.label ?? ""}</p>
                  <p className="fs-13 fw-500" style={{ color: "#3F9A30" }}>
                    Running from
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <p className="fs-13 fw-500 text-white rounded-pill px-4 py-2 text-center m-0" style={{ backgroundColor: "#3F9A30" }}>
                      On
                    </p>
                    <span
                      style={{
                        backgroundColor: "#7161b8ff",
                        width: "4px",
                        height: "4px",
                      }}
                    ></span>
                    <p className="m-0 fs-12 fw-500 d-flex align-items-center gap-1">
                      <Clock size={13} /> {lastUpdate ?? ""}
                    </p>
                  </div>
                </div>
                {!showSlider ? (
                  <button onClick={() => setShowSlider(true)} className="border-0 mt-3 mt-xl-0 px-3 py-2 d-flex align-items-center gap-2 text-white rounded-pill" style={{ backgroundColor: "#7157C2" }}>
                    <img src={playback} alt="playback" />
                    Play back
                  </button>
                ) : (
                  <div className="d-flex gap-3 slider align-items-center text-white p-3 rounded-pill" style={{ width: "620px" }}>
                    <div className="text-start" style={{ width: "80px" }}>
                      <div className="text-muted small">{startDate ?? ""}</div>
                      <div className="small text-muted"> {startTime ?? ""}</div>
                    </div>
                    <div style={{ width: "400px" }}>
                      <input
                        type="range"
                        min={0}
                        max={totalDurationHours > 0 ? totalDurationHours : 1}
                        value={endHour}
                        onChange={handleChange}
                        className="custom-slider"
                        style={{
                          width: "100%",
                          height: "8px",
                          borderRadius: "4px",
                          background: `linear-gradient(to right, ${totalDurationHours === 0 ? "#D9DFE7" : "#386AE4"} ${(endHour / (totalDurationHours || 1)) * 100}%, #e9ecef ${(endHour / (totalDurationHours || 1)) * 100}%)`,
                          appearance: "none",
                          outline: "none",
                        }}
                      />
                      <div style={{ marginTop: "8px" }}>End Time: {formatEndTime(endTime)}</div>
                    </div>

                    <div className="text-end" style={{ width: "80px" }}>
                      <div className="text-muted small">{endDate ?? ""}</div>
                      <div style={{ marginTop: "8px" }}>{endTime ? `${endTime.getFullYear()}-${String(endTime.getMonth() + 1).padStart(2, "0")}-${String(endTime.getDate()).padStart(2, "0")} ${String(endTime.getHours()).padStart(2, "0")}:${String(endTime.getMinutes()).padStart(2, "0")}:${String(endTime.getSeconds()).padStart(2, "0")}` : ""}</div>
                    </div>
                    {/* <button
                        
                        className="btn btn-light rounded-circle ms-2 d-flex justify-content-center align-items-center p-0"
                        style={{ width: "46px", height: "46px" }}
                      >
                        X
                      </button> */}
                    <img src={close} alt="" className="" onClick={() => setShowSlider(false)} />
                  </div>
                )}
              </div>
              {isLoaded && (
                <GoogleMap key={updateFlag} mapContainerStyle={{ width: "100%", height: 400 }} center={center} zoom={zoom}>
                  {/* Markers */}
                  {marker &&
                    marker.length > 0 &&
                    marker.map((m) => (
                      <Marker
                        key={m.id}
                        position={m.position}
                        icon={{
                          path: mapLorryFlag,
                          scaledSize: new window.google.maps.Size(50, 50),
                        }}
                      />
                    ))}

                  {/* Polyline */}
                  {flagMarker && <Marker key={flagMarker.id} position={flagMarker.position} icon={flagMarker.icon} />}
                  {Object.entries(polylines).map(([id, { path, type }]) => (
                    <Polyline
                      key={id}
                      path={path}
                      options={{
                        strokeColor: type === "history" ? "#008000" : "#FF0000",
                        strokeOpacity: 1,
                        strokeWeight: type === "history" ? 3 : 4,
                      }}
                    />
                  ))}
                </GoogleMap>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
